/**
 * Plain <a href> links for privacy/terms. Google OAuth branding verification
 * crawls the homepage without running React; buttons and client-side routing are invisible.
 * Use absolute URLs matching FRONTEND_URL / OAuth home page (terrakronos.com).
 */
const SITE_ORIGIN =
  (process.env.REACT_APP_PUBLIC_SITE_URL || "https://terrakronos.com").replace(/\/+$/, "");

export const PRIVACY_URL = `${SITE_ORIGIN}/privacy`;
export const TERMS_URL = `${SITE_ORIGIN}/terms`;

export function LegalSiteLinks({ className = "", linkClassName = "hover:text-foreground transition-colors" }) {
  return (
    <span className={className}>
      <a href={PRIVACY_URL} className={linkClassName}>
        Privacy Policy
      </a>
      <span className="mx-2 text-muted-foreground" aria-hidden="true">
        |
      </span>
      <a href={TERMS_URL} className={linkClassName}>
        Terms of Service
      </a>
    </span>
  );
}
